import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=84a8b0ae&scoped=true&"
import script from "./Alert.vue?vue&type=script&lang=js&"
export * from "./Alert.vue?vue&type=script&lang=js&"
import style0 from "./Alert.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Alert.vue?vue&type=style&index=1&id=84a8b0ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a8b0ae",
  null
  
)

export default component.exports